import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import api from '../services/api';

export default function BootGate({ children }) {
  const [status, setStatus] = useState('checking'); // checking | up | down
  const [lastError, setLastError] = useState('');

  const check = async () => {
    setStatus('checking');
    setLastError('');
    try {
      // Lightweight public endpoint
      const res = await api.get('/Auth/test');
      if (res) {
        setStatus('up');
      } else {
        setStatus('down');
      }
    } catch (e) {
      setLastError(e?.message || '');
      setStatus('down');
    }
  };

  useEffect(() => { check(); }, []);

  if (status === 'checking') {
    return (
      <Box sx={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', flexDirection:'column', gap:2 }}>
        <CircularProgress size={48} />
        <Typography variant="h6">Зареждане на приложението…</Typography>
        <Typography variant="body2" color="text.secondary">Моля изчакайте, докато подготвим всичко.</Typography>
      </Box>
    );
  }

  if (status === 'down') {
    return (
      <Box sx={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', textAlign:'center', p:3, flexDirection:'column', gap:2 }}>
        <Typography variant="h5" gutterBottom>Приложението не е стартирано</Typography>
        <Typography variant="body1" color="text.secondary">
          Не успяхме да се свържем с бекенда. Уверете се, че API-то работи и опитайте отново.
        </Typography>
        {lastError && (
          <Typography variant="caption" color="text.secondary">{String(lastError)}</Typography>
        )}
        <Button variant="contained" onClick={check} sx={{ mt:1 }}>Опитай отново</Button>
      </Box>
    );
  }

  return children;
}

